/**
 * ================================================================
 * cart-recommendations.js
 * Ruta: assets/cart-recommendations.js
 * ================================================================
 */

(function () {
  'use strict';

  const CONFIG = {
    rootSelector:   '#cart-rec-root',
    slidesSelector: '#cart-rec-slides',
    btnPrev:        '.cart-rec__btn-prev',
    btnNext:        '.cart-rec__btn-next',
    currentEl:      '.cart-rec__current',
    totalEl:        '.cart-rec__total',
    maxProducts:    5,
    currencySymbol: '$',
    defaultLabel:   'Agregar',
    addedLabel:     '✓',
    addingLabel:    '...',
  };

  let swiperInstance   = null;
  let collectionHandle = '';
  let initialized      = false;
  let productsLoaded   = false;

  /* ----------------------------------------------------------------
     HELPERS
  ---------------------------------------------------------------- */

  function formatMoney(price) {
    const amount = Math.round(parseFloat(price));
    return CONFIG.currencySymbol + amount.toLocaleString('es-CL');
  }

  function starsHTML() {
    const star = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 1l2.39 4.84 5.34.78-3.86 3.76.91 5.33L10 13.27l-4.78 2.51.91-5.33L2.27 6.62l5.34-.78z"/></svg>';
    return '<div class="cart-rec__stars">' + star.repeat(5) + '</div>';
  }

  function buildCard(product) {
    const variant        = product.variants[0];
    const variantId      = variant.id;
    const price          = formatMoney(variant.price);
    const compareAtRaw   = parseFloat(variant.compare_at_price) || 0;
    const priceRaw       = parseFloat(variant.price) || 0;
    const isOnSale       = compareAtRaw > priceRaw;
    const comparePriceHTML = isOnSale
      ? '<span class="cart-rec__compare-price">' + formatMoney(variant.compare_at_price) + '</span>'
      : '';
    // La Collections API no devuelve product.url — construirlo desde handle
    const productUrl = '/products/' + product.handle;

    let rawSrc = '';
    if (product.featured_image) {
      rawSrc = typeof product.featured_image === 'object'
        ? (product.featured_image.src || '')
        : product.featured_image;
    } else if (product.images && product.images.length > 0) {
      rawSrc = typeof product.images[0] === 'object'
        ? (product.images[0].src || '')
        : product.images[0];
    }

    const imgSrc = rawSrc
      ? rawSrc.replace(/(\.[^.?]+)(\?|$)/, '_160x160$1$2')
      : '';

    const imgTag = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + product.title + '" loading="lazy" width="64" height="64">'
      : '<div style="width:64px;height:64px;background:#ddd;border-radius:6px;"></div>';

    return `
      <div class="cart-rec__card">
        <a class="cart-rec__img" href="${productUrl}" tabindex="-1" aria-hidden="true">
          ${imgTag}
        </a>
        <div class="cart-rec__info">
          <a class="cart-rec__name" href="${productUrl}">${product.title}</a>
          ${starsHTML()}
          <div class="cart-rec__price${isOnSale ? ' on-sale' : ''}">${price} ${comparePriceHTML}</div>
        </div>
        <button
          class="cart-rec__add"
          type="button"
          data-variant-id="${variantId}"
        >${CONFIG.defaultLabel}</button>
      </div>
    `;
  }

  /* ----------------------------------------------------------------
     RENDER
  ---------------------------------------------------------------- */

  function renderSlides(products) {
    const container = document.querySelector(CONFIG.slidesSelector);
    if (!container) return;

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    container.innerHTML = products
      .map(p => '<div class="swiper-slide">' + buildCard(p) + '</div>')
      .join('');

    updatePager(1, products.length);
    productsLoaded = true;
  }

  /* ----------------------------------------------------------------
     SWIPER
  ---------------------------------------------------------------- */

  function initSwiper() {
    if (!productsLoaded) return;

    const swiperEl = document.querySelector(CONFIG.rootSelector + ' .cart-rec__swiper');
    if (!swiperEl) return;

    // Si Swiper no está disponible globalmente, cargarlo desde CDN
    if (typeof Swiper === 'undefined') {
      if (document.getElementById('cart-rec-swiper-cdn')) return; // ya se está cargando
      var script = document.createElement('script');
      script.id  = 'cart-rec-swiper-cdn';
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.onload = function () { initSwiper(); };
      document.head.appendChild(script);
      return;
    }

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    swiperInstance = new Swiper(swiperEl, {
      slidesPerView:  1.15,
      spaceBetween:   10,
      loop:           false,
      observer:       true,
      observeParents: true,
      resizeObserver: true,
      a11y:           { enabled: false },
      on: {
        slideChange: function () {
          updatePager(this.activeIndex + 1, this.slides.length);
          updateNavButtons(this);
        },
        init: function () {
          updateNavButtons(this);
        },
      },
    });

    bindNavButtons();
  }

  function bindNavButtons() {
    // No hacer nada aquí — la delegación está en bindGlobalNav
  }

  // Delegación global — no afectada por trapFocus de Impulse
  function bindGlobalNav() {
    ['mousedown', 'touchend'].forEach(function (evtType) {
      document.addEventListener(evtType, function (e) {
        var btn = e.target.closest('.cart-rec__btn-prev, .cart-rec__btn-next');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('cart-rec__btn-prev') && swiperInstance) swiperInstance.slidePrev();
        if (btn.classList.contains('cart-rec__btn-next') && swiperInstance) swiperInstance.slideNext();
      }, true); // useCapture: true — se ejecuta antes que cualquier otro listener
    });
  }

  function updatePager(current, total) {
    const root = document.querySelector(CONFIG.rootSelector);
    if (!root) return;
    const cur = root.querySelector(CONFIG.currentEl);
    const tot = root.querySelector(CONFIG.totalEl);
    if (cur) cur.textContent = current;
    if (tot) tot.textContent = total;
  }

  function updateNavButtons(swiper) {
    const root = document.querySelector(CONFIG.rootSelector);
    if (!root) return;
    const btnPrev = root.querySelector(CONFIG.btnPrev);
    const btnNext = root.querySelector(CONFIG.btnNext);
    if (btnPrev) btnPrev.disabled = swiper.isBeginning;
    if (btnNext) btnNext.disabled = swiper.isEnd;
  }

  /* ----------------------------------------------------------------
     REINICIALIZAR SWIPER — llamar después de cualquier cambio
  ---------------------------------------------------------------- */

  var reinitTimer = null;
  function scheduleReinit() {
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(function () {
      var cartDrawer = document.getElementById('CartDrawer');
      if (!cartDrawer || !cartDrawer.classList.contains('drawer--is-open')) return;
      initSwiper();
      if (swiperInstance) updateNavButtons(swiperInstance);
    }, 400);
  }

  /* ----------------------------------------------------------------
     DETECTAR APERTURA DEL DRAWER
  ---------------------------------------------------------------- */

  function bindDrawerOpen() {
    // Evento nativo de Impulse
    document.addEventListener('drawerOpen.CartDrawer', function () {
      setTimeout(function () {
        initSwiper();
        if (swiperInstance) updateNavButtons(swiperInstance);
      }, 350);
    });

    // MutationObserver en clase del drawer
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    var lastOpen = false;
    new MutationObserver(function () {
      var isOpen = cartDrawer.classList.contains('drawer--is-open');
      if (isOpen && !lastOpen) {
        lastOpen = true;
        setTimeout(function () {
          initSwiper();
          if (swiperInstance) updateNavButtons(swiperInstance);
        }, 350);
      } else if (!isOpen) {
        lastOpen = false;
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });

    // cart:updated — Impulse lo dispara después de cada cambio en el carrito
    // Esperar 400ms para que Impulse termine de rerenderizar el drawer
    document.addEventListener('cart:updated', scheduleReinit);
  }

  /* ----------------------------------------------------------------
     FETCH COLECCIÓN
  ---------------------------------------------------------------- */

  async function loadProducts() {
    const url = '/collections/' + collectionHandle + '/products.json?limit=' + CONFIG.maxProducts;
    try {
      const res  = await fetch(url);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      const products = (data.products || []).slice(0, CONFIG.maxProducts);
      if (products.length > 0) renderSlides(products);
    } catch (err) {
      console.warn('[CartRec] Error cargando coleccion:', err);
    }
  }

  /* ----------------------------------------------------------------
     AGREGAR AL CARRITO
  ---------------------------------------------------------------- */

  function resetButtons() {
    const slides = document.querySelector(CONFIG.slidesSelector);
    if (!slides) return;
    slides.querySelectorAll('.cart-rec__add').forEach(function (btn) {
      btn.textContent = CONFIG.defaultLabel;
      btn.classList.remove('is-added', 'is-loading');
      btn.disabled = false;
    });
  }

  function bindAddButtons() {
    const slides = document.querySelector(CONFIG.slidesSelector);
    if (!slides) return;

    slides.addEventListener('click', function (e) {
      const btn = e.target.closest('.cart-rec__add');
      if (!btn || btn.disabled) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.textContent = CONFIG.addingLabel;
      btn.disabled    = true;

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 }),
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Error');
        btn.textContent = CONFIG.addedLabel;
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        btn.textContent = CONFIG.defaultLabel;
        btn.disabled    = false;
      });
    });

    document.addEventListener('cart:updated', resetButtons);
  }

  /* ----------------------------------------------------------------
     INIT
  ---------------------------------------------------------------- */

  function init() {
    const root = document.querySelector(CONFIG.rootSelector);
    if (!root) return;

    collectionHandle = root.dataset.collectionHandle || '';
    if (!collectionHandle) return;

    bindAddButtons();
    bindDrawerOpen();
    bindGlobalNav();
    loadProducts();
  }

  function boot() {
    if (initialized) return;
    initialized = true;
    // Resetear estado en cada carga de página
    swiperInstance   = null;
    productsLoaded   = false;
    collectionHandle = '';
    init();
  }

  // Resetear en cada navegación para que boot() pueda correr de nuevo
  document.addEventListener('page:load', function () {
    initialized = false;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    document.addEventListener('page:loaded', boot, { once: true });
    setTimeout(boot, 300);
  }

})();